import React from 'react';
// import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import { Select } from '../../../components';

import './style.scss';

const ThemesSelectOverview = ({ loading, entities, ...props }) => {
  const { entity } = props;
  const history = useHistory();
  const options = [];

  entities.map((entity) => {
    options.push({ value: entity.getIn(['tid', 0, 'value']), label: entity.getIn(['name', 0, 'value']), entity: entity });
  });

  const selectChanged = (value) => {
    history.push(value.entity.getIn(['paths', 'nl']));
  };

  return (
    <div className="View ThemesSelectOverview input__select">
      <div className="label">Wissel van thema:</div>
      <Select
        options={options}
        defaultValue={entity.getIn(['tid', 0, 'value'])}
        className="Filter__select"
        handleChange={selectChanged}
        placeholder={entity.getIn(['name', 0, 'value'])}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: '#ffe37e',
            primary: '#9ab4c9',
          },
        })} />
    </div>
  );
};

export default ThemesSelectOverview;
